import Logo from '../logo';
import MobileMenu from '../mobile-menu';
import RightNav from './right-nav';

export default function ScrolledHeader() {
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-6">
      <div className="flex items-center justify-between h-16 md:h-16">
        {/* Site branding */}
        <div className="shrink-0 mr-5 relative -left-[9px] md:-top-1">
          <Logo size="small" />
        </div>

        <nav className="hidden md:flex md:grow">
          <RightNav scrolled />
        </nav>

        <MobileMenu />
      </div>
    </div>
  );
}
